import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { User } from '../_models/user';
import { Globals } from '../_globals/globals';


@Injectable({
  providedIn: 'root'
})

export class AuthenticationService {
  public currentUser: Observable<User>;
  private currentUserSubject: BehaviorSubject<User>;

  constructor(
    private http: HttpClient,
    private globals: Globals
  ) {
    this.currentUserSubject = new BehaviorSubject<User>(JSON.parse(localStorage.getItem('currentUser')));
    this.currentUser = this.currentUserSubject.asObservable();
  }

  public get currentUserValue(): User {
    return this.currentUserSubject.value;
  }

  // Función que llama a la función del controlador (mediante un POST) que comprueba y loguea al usuario.
  login(email: string, password: string) {
    return this.http.post<User>(this.globals.apiUrl + '/auth/login', {email, password})
      .pipe(map(user => {

        console.log('-> AuthenticationService -> Usuario logueado desde login:');
        // console.log(user);

        // login successful if there's a jwt token in the response
        if (user && user.token) {

          // store user details and jwt token in local storage to keep user logged in between page refreshes
          localStorage.setItem('currentUser', JSON.stringify(user));
          localStorage.setItem('user_id', user.user_id.toString());
          localStorage.setItem('role', user.role);
          localStorage.setItem('lang', user.lang);
          localStorage.setItem('company', user.company);
          localStorage.setItem('company_email', user.company_email);
          localStorage.setItem('company_phone', user.company_phone);
          localStorage.setItem('token', user.token);
          localStorage.setItem('name', user.name);
          localStorage.setItem('email', user.email);
          localStorage.setItem('phone', user.phone);
          localStorage.setItem('enviroment', user.enviroment);
          localStorage.setItem('permissions', user.permissions);
          localStorage.setItem('group_id', user.group_id.toString());
          this.currentUserSubject.next(user);
        }
        return user;
      }));
  }

  logout() {
    // remove user from local storage to log user out
    localStorage.removeItem('currentUser');
    localStorage.removeItem('user_id');
    localStorage.removeItem('role');
    localStorage.removeItem('lang');
    localStorage.removeItem('company');
    localStorage.removeItem('company_email');
    localStorage.removeItem('company_phone');
    localStorage.removeItem('token');
    localStorage.removeItem('name');
    localStorage.removeItem('email');
    localStorage.removeItem('phone');
    localStorage.removeItem('enviroment');
    localStorage.removeItem('permissions');
    localStorage.removeItem('group_id');
    this.currentUserSubject.next(null);
  }

  redirectToLoginForAccessBlock(messageIn?: string): void {
    sessionStorage.setItem('dimpro_access_block_message', messageIn || 'Tu acceso ha sido bloqueado. Contacta con soporte.');
    this.logout();
    window.location.assign('/login?reason=access_blocked');
  }

  refreshToken(): Observable<User> {
    const currentUser = JSON.parse(localStorage.getItem('currentUser'));
    const token = currentUser.refreshToken;

    console.log('-->->* AuthenticationService: Refrescando token...');

    // return this.http.post<User>("http://localhost:53217/api/Account/Token/Refresh", { 'token': token })
    return this.http.post<User>(this.globals.apiUrl + '/auth/refresh', { token })
      .pipe(
        map(user => {
          if (user && user.token) {

            console.log('refreshToken --> Usuario autenticado:');
            console.log(user);

            // store user details and jwt token in local storage to keep user logged in between page refreshes
            localStorage.setItem('currentUser', JSON.stringify(user));
            localStorage.setItem('user_id', user.user_id.toString());
            localStorage.setItem('role', user.role);
            localStorage.setItem('lang', user.lang);
            localStorage.setItem('company', user.company);
            localStorage.setItem('token', user.token);
            localStorage.setItem('name', user.name);
            localStorage.setItem('email', user.email);
            localStorage.setItem('enviroment', user.enviroment);
            localStorage.setItem('permissions', user.permissions);
            localStorage.setItem('group_id', user.group_id.toString());
            this.currentUserSubject.next(user);
          } else {
            console.log('refreshToken -> *** Usuario NO autenticado:');
            console.log(user);
          }
          return user as User;
      }));
  }
}
